import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ENDPOINT_DATA_AXURE, PointDialogStates } from '../../../constants';
import { customFetch, dataAxureFetch } from '../../../helpers/fetch';
import { Confirmation } from '../../ui/dialog/Confirmation';
import PointDialog from './PointDialog';
import PointsTable from './PointsTable';



const PointsTableContainer = () => {
    const uid = useSelector((state) => state.auth.uid);
    const uptws = useSelector((state) => state.auth.ptws);
    const [tableLoading, setTableLoading] = useState(false);
    const [points, setPoints] = useState([]);
    const [pointDialogState, setPointDialogState] = useState(PointDialogStates.CLOSED);
    const [pointDialogLoading, setPointDialogLoading] = useState(false);
    const [dialogPoint, setDialogPoint] = useState(null);
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [pointSelector, setpointSelector] = useState({})

    /**
     * Get Points
     */
    useEffect(() => {
        getPoints();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Get points and send information to the table 
     */
    const getPoints = async () => {
        try {
            setTableLoading(true);
            const newPoints = await dataAxureFetch(
                {
                    solicitud: "NomPuntosDetalle",
                    idCliente: uid,
                    ptws: uptws,
                },
                'POST'
            )
            setPoints(newPoints);
        } catch (error) {
            console.log(error);
        } finally {
            setTableLoading(false);
        }
    };

    /**
     * Create point 
     * @param {object} point -Information with the point to be created 
     */
    const createPoint = async (point) => {
        try {
            setPointDialogLoading(true);
            await dataAxureFetch(
                {
                    nombre: point.nombre,
                    lat: point.latitud,
                    lon: point.longitud,
                    cliente: point.cliente,
                    zona: point.zona,
                    sat: point.sat,
                    correos: point.correos,
                    idCliente: uid,
                },
                'POST'
            );
            setPointDialogLoading(false);
            setPointDialogState(PointDialogStates.CLOSED);
            await getPoints();
        } catch (error) {
            setPointDialogLoading(false);
            console.log(error);
        }
    };

    /**
     * Open the dialog to edit/create point 
     * @param {Number} id -Id of the point
     */
    const openPointDialog = async (id) => {
        const response = await customFetch(`${ENDPOINT_DATA_AXURE}?id=${id}`, undefined);
        const point = response[0];
        setDialogPoint(point);
        setPointDialogState(PointDialogStates.EDITION);
    };

    /**
     * Edit the point
     * @param {object} point {objet with info of the point}
     */
    const editPoint = async (point) => {
        try {
            setPointDialogLoading(true);
            await dataAxureFetch(point, 'PUT');
            setPointDialogLoading(false);
            setPointDialogState(PointDialogStates.CLOSED);
            await getPoints();
        } catch (error) {
            console.log(error);
        }
    };


    /**
     * Delete point
     * @param {number} point id of the point
     */
    const deletePoint = async (point) => {
        try {
            await customFetch(`${ENDPOINT_DATA_AXURE}${point.id}`, undefined, 'DELETE');
            await getPoints();
        } catch (error) {
            console.log(error);
        }
    };

    /**
   * Send information of offer
   */
    const handleClick = async (point) => {
        
        try {
            await deletePoint(pointSelector)
            setOpenConfirmation(false);
        } catch (error) {
            console.log(error);
        }
       
    }

    const confirmDIalog = (point) => {
        setOpenConfirmation(true);
        setpointSelector(point)
    }

    /**
   * Close dialog
   */
   const handleClose = () => {
    setOpenConfirmation(false);
  };

    return (
        <>
            <Confirmation
                title="Advertencia"
                msgError="Está seguro de eliminar?"
                open={openConfirmation}
                onClose={handleClose}
                onClick={handleClick}
            />
            <PointsTable
                createPoint={() => setPointDialogState(PointDialogStates.CREATION)}
                deletePoint={confirmDIalog}
                editPoint={openPointDialog}
                getPoints={getPoints}
                loading={tableLoading}
                points={points}
            />
            <PointDialog
                close={() => setPointDialogState(PointDialogStates.CLOSED)}
                createPoint={createPoint}
                editPoint={editPoint}
                loading={pointDialogLoading}
                point={dialogPoint}
                state={pointDialogState}
            />
        </>
    );
};

export default PointsTableContainer;
